var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ2Unlock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.23 11.94a11.93 11.93 0 00-9-3.24A12.23 12.23 0 0047 21.07V27H17v36h42V27h-8v-5.93a8.22 8.22 0 017.5-8.38 8 8 0 018.5 8V28h4v-7.32a12.09 12.09 0 00-3.77-8.74zM55 31v28H21V31h34zM40 53h-4V38h4v15z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J2_Unlock.452ec5e3.svg";
export { SvgJ2Unlock as ReactComponent };